var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57583 4.57546C4.74774 4.40354 5.00641 4.35237 5.23084 4.44587L12.2308 7.36219C12.4612 7.45818 12.6082 7.68678 12.5998 7.93624C12.5914 8.1857 12.4294 8.4039 12.1931 8.48417L10.0581 9.20929L12.0242 11.1753C12.2585 11.4097 12.2585 11.7896 12.0242 12.0239C11.7899 12.2582 11.41 12.2582 11.1756 12.0239L9.20963 10.0578L8.48454 12.1927C8.40427 12.429 8.18606 12.591 7.93661 12.5994C7.68715 12.6078 7.45855 12.4609 7.36256 12.2305L4.44623 5.23047C4.35273 5.00604 4.40391 4.74738 4.57583 4.57546ZM6.11426 6.1139L7.85925 10.3024L8.38365 8.75844C8.44361 8.58189 8.58225 8.44325 8.75881 8.38328L10.3027 7.85889L6.11426 6.1139Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66672 0.299805C1.35964 0.299805 0.300049 1.3594 0.300049 2.66647V14.3331C0.300049 15.6402 1.35964 16.6998 2.66672 16.6998H14.3334C15.6405 16.6998 16.7 15.6402 16.7 14.3331V2.66647C16.7 1.3594 15.6405 0.299805 14.3334 0.299805H2.66672ZM1.70005 2.66647C1.70005 2.1326 2.13284 1.6998 2.66672 1.6998H14.3334C14.8673 1.6998 15.3 2.1326 15.3 2.66647V14.3331C15.3 14.867 14.8673 15.2998 14.3334 15.2998H2.66672C2.13284 15.2998 1.70005 14.867 1.70005 14.3331V2.66647Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoIcon);
export default __webpack_public_path__ + "static/media/autoIcon.b8ed0c020d04ccee56097895c31ee75b.svg";
export { ForwardRef as ReactComponent };